import React, { useEffect } from 'react';

// mui
import { Button, Grid, styled, Tooltip } from '@mui/material';

// icons
import { Close, OpenInNew } from '@mui/icons-material';

// util
import { useNavigate } from 'react-router';
import WorkflowProgressView from '../WorkflowProgressView/WorkflowProgressView';

// styled components
const SessionBox = styled(Grid)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: '8px',
  background: theme.palette.background.paper,
}));

const OuterItem = styled(Grid)({
  padding: '0px 8px 0px 8px',
});

const TextButton = styled(Button)(({ theme }) => ({
  textTransform: 'unset !important',
  color: theme.palette.text.primary,
}));

const CloseIcon = styled(Close)(({ theme }) => ({
  width: '18px !important',
  height: '18px !important',
  '&:hover': {
    cursor: 'pointer',
    color: `${theme.palette.text.primary} !important`,
  },
}));

const OpenInNewIcon = styled(OpenInNew)(({ theme }) => ({
  width: '18px !important',
  height: '18px !important',
  '&:hover': {
    cursor: 'pointer',
    color: `${theme.palette.text.primary} !important`,
  },
}));

function SelectedSessionBox({ selectedSession, closeSelectedSession, refreshSessions }) {
  const navigate = useNavigate();

  useEffect(() => {
    // Update the URL params accordingly
    // depending on what session is selected
    const params = new URLSearchParams(window.location.search);
    params.set('viewSession', selectedSession.projectSessionId);
    navigate({ search: params.toString() });
  }, [selectedSession]);

  const handleClose = () => {
    // Remove the param
    const params = new URLSearchParams(window.location.search);
    params.delete('viewSession');
    navigate({ search: params.toString() });

    // Close the selected session
    closeSelectedSession();
  };

  const openInNewTab = () => {
    if (!selectedSession) return;
    const isTest = Boolean(selectedSession.projectTestId);
    const url = `/project/logs/progress_view/${selectedSession.projectId}/${selectedSession.projectSessionId}?test=${isTest}`;
    window.open(url, '_blank');
  };

  return (
    <OuterItem container>
      <Grid item xs={12}>
        <Grid
          container
          display="flex"
          alignItems="center"
          justifyContent="flex-end"
          gap="4px"
          padding="6px 0px"
        >
          <Grid item onClick={openInNewTab} id="open-progress-view-session">
            <OpenInNewIcon />
          </Grid>
          <Grid item onClick={handleClose} id="close-progress-view-session">
            <CloseIcon />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <SessionBox container>
          <WorkflowProgressView
            isSplitView
            id={selectedSession.projectId}
            project_session_id={selectedSession.projectSessionId}
            isTest={Boolean(selectedSession.projectTestId)}
            refreshSessions={refreshSessions}
          />
        </SessionBox>
      </Grid>
    </OuterItem>
  );
}

export default SelectedSessionBox;
